import { IChildrenProp, IDiv } from 'types/components/components.interface';
import './MagellanPopupHeader.scss';

interface IMagellanPopupHeaderProps extends IChildrenProp, IDiv {}

const MagellanPopupHeader = ({
  children,
  className = '',
  ...props
}: IMagellanPopupHeaderProps) => {
  return (
    <div {...props} className={`magellan-popup-header ${className}`}>
      {children}
    </div>
  );
};

export default MagellanPopupHeader;
